/*
akhila 11/09/2022 3225733165 added owned and assigned tabs.
akhila 11/10/2022 3225733165 changed tabs order.
Akhila 03/06/2023 3225733165 Added assigned and owned Form
*/

import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useDispatch} from 'react-redux';
import {resetData} from '../../../redux/reducers/WorkQueueList';
import AssignedForm from './AssignedForm';
import OwnedForm from './OwnedForm';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function EnableFrameworkTabs({value}) {
  const dispatch = useDispatch();
  useEffect(() => {
    sessionStorage.removeItem('workQueueNextAccount');
    dispatch(resetData());
  }, []);
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {value === 0 && 
        <h2 className="search-title">Work Queue Assigned Search</h2>
      }
      {value === 1 &&       
        <h2 className="search-title">Work Queue Owned Search</h2>
      }
      <div className={classes.subContent}>
        {value === 0 && <AssignedForm value={value} />}
        {value === 1 && <OwnedForm value={value} />}
      </div>
    </div>
  );
}
